import { CountryPhoneInputValue } from "antd-country-phone-input"
import { BookingAssessmentForm } from "../../../modules/booking-assessment/providers/booking-assessment.provider"

export const saveGuestInfo = (data: {
  name: string
  email: string
  phone_number: CountryPhoneInputValue
}) => {
  localStorage.setItem("guestInfo", JSON.stringify(data))
}

export const getGuestInfo = () => {
  if (typeof window === "undefined") return null
  const item = localStorage.getItem("guestInfo")
  return item ? JSON.parse(item) : null
}

export const clearGuestInfo = () => {
  localStorage.removeItem("guestInfo")
}

export const saveBookingAssessmentInfo = (data: BookingAssessmentForm) => {
  localStorage.setItem("bookingAssessmentInfo", JSON.stringify(data))
}

export const getBookingAssessmentInfo = () => {
  if (typeof window === "undefined") return null
  const item = localStorage.getItem("bookingAssessmentInfo")
  return item ? JSON.parse(item) : null
}

export const clearBookingAssessmentInfo = () => {
  localStorage.removeItem("bookingAssessmentInfo")
}
